import { __decorate, __metadata } from "tslib";
import { AppRequestMethod } from '@core/shared/request';
import { AppRequest } from '@core/shared/app-request';
import { Expose, Model, Type, ModelId } from '@core/shared/model';
import { CourseItem, SceneItem } from '../models';
import { ExamProgressResponse } from './exam-progress.request';
let SceneMostRecentProgressResponse = /*#__PURE__*/(() => {
  let SceneMostRecentProgressResponse = class SceneMostRecentProgressResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", SceneItem)], SceneMostRecentProgressResponse.prototype, "scene", void 0);
  __decorate([Expose(), __metadata("design:type", CourseItem)], SceneMostRecentProgressResponse.prototype, "course", void 0);
  __decorate([Expose(), Type(() => ExamProgressResponse), __metadata("design:type", ExamProgressResponse)], SceneMostRecentProgressResponse.prototype, "progress", void 0);
  SceneMostRecentProgressResponse = __decorate([ModelId("SceneMostRecentProgressResponse") // auto-generated by generate-model-ids
  ], SceneMostRecentProgressResponse);
  return SceneMostRecentProgressResponse;
})();
export { SceneMostRecentProgressResponse };
let SceneMostRecentProgressRequest = /*#__PURE__*/(() => {
  let SceneMostRecentProgressRequest = class SceneMostRecentProgressRequest extends Model {
    static {
      this.Response = SceneMostRecentProgressResponse;
    }
  };
  SceneMostRecentProgressRequest = __decorate([AppRequest('courses', 'scenes/progress/most-recent', {
    httpMethod: AppRequestMethod.POST,
    requiredAccessData: ['userId', 'isLoggedIn']
  }), ModelId("SceneMostRecentProgressRequest") // auto-generated by generate-model-ids
  ], SceneMostRecentProgressRequest);
  return SceneMostRecentProgressRequest;
})();
export { SceneMostRecentProgressRequest };